var _desc, _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\r\n\t\t\tCreated with Pixso.\r\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4479_6278"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u0438\\u043A\\u043E\\u043D\\u043A\\u0438 \\u043F\\u043E\\u043B\\u044C\\u0437\\u043E\\u0432\\u0430\\u0442\\u0435\\u043B\\u044F",
    rx: 54,
    width: 108,
    height: 108,
    transform: "translate(0.500000 0.500000)",
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "\\u0438\\u043A\\u043E\\u043D\\u043A\\u0438 \\u043F\\u043E\\u043B\\u044C\\u0437\\u043E\\u0432\\u0430\\u0442\\u0435\\u043B\\u044F",
    rx: 54,
    width: 108,
    height: 108,
    transform: "translate(0.500000 0.500000)",
    fill: "#000000",
    fillOpacity: 0.12
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4479_6278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M52.83 53.67L56.17 53.67C59.71 53.67 63.11 52.24 65.62 49.7C68.13 47.16 69.53 43.72 69.53 40.13L69.53 31.19C69.54 28.17 68.36 25.27 66.25 23.14C64.15 21 61.29 19.8 58.31 19.81L50.69 19.81C47.7 19.8 44.84 21 42.74 23.14C40.63 25.27 39.45 28.17 39.46 31.19L39.46 40.13C39.46 47.61 45.44 53.67 52.83 53.67ZM38.99 87.53L70 87.53C73.38 87.4 76.53 85.75 78.58 83.04C80.64 80.32 81.39 76.81 80.63 73.48L79.83 69.62C78.91 64.39 74.47 60.55 69.23 60.44L39.76 60.44C34.52 60.55 30.09 64.39 29.16 69.62L28.36 73.48C27.6 76.81 28.35 80.32 30.41 83.04C32.46 85.75 35.61 87.4 38.99 87.53Z",
    fill: "#000000",
    fillOpacity: 0.56,
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMan);
export default __webpack_public_path__ + "static/media/icon_man.af7dbc67fbe9fa2e4f732483f3b1c832.svg";
export { ForwardRef as ReactComponent };